import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

const freeConsultationText = css`
  margin-bottom: 8px;
`;

type IndividualDesignProps = {
  onConsultationSignupBtnClick: () => void;
};

export const IndividualDesign = ({ onConsultationSignupBtnClick }: IndividualDesignProps) => (
  <>
    <ModalHeader title="Индивидуальный дизайн" />
    <ModalContent>
      <Typography className={freeConsultationText} variant="m" size="body_long">
        Мы&nbsp;делаем двери под заказ любого дизайна и&nbsp;размера.
      </Typography>
      <Typography variant="m" size="body_long">
        У&nbsp;нас большой выбор материалов&nbsp;&mdash; эмаль, ПВХ-плёнка, натуральный шпон и&nbsp;другие.
        И&nbsp;богатая цветовая палитра&nbsp;&mdash; подберём нужный оттенок по&nbsp;RAL. А&nbsp;ещё легко
        оформим входную дверь под дизайн вашего пространства, поможем выбрать надёжный замок
        с&nbsp;фурнитурой, а&nbsp;для ценителей эстетики&nbsp;&mdash; предложим множество вариантов
        фрезеровки и&nbsp;остекления.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementName="Индивидуальный дизайн"
        elementText="Оставить заявку"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
